export default __webpack_public_path__ + "static/media/AspenLanding.8dd9ae8f.jpg";